import ActiveRecord from './active_record/base'

class BillingInfo extends ActiveRecord {
	static tableName = 'billingInfos'
	static sort = 'company_name'

	async getPaymentUrl() {
		return await this.resourceReq('mollie_consent_payment_url', {method: 'get'})
	}

	async getPaymentStatus({paymentId}) {
		// putting payment_id as a query param explicitly, otherwise it ends up in the billing_info scope which is not expected by the BE
		return await this.resourceReq(`mollie_payment_status?payment_id=${paymentId}`, {doLoad: true, skipSuccessNotif: true, method: 'get'})
	}

	sign(data) {
		return this.resourceReq('sign', {...data, method: 'post'})
	}

	updateEnvironments(environment_ids) {
		return this.resourceReq('update_environments', {environment_ids})
	}
}

export default BillingInfo
